const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ------------------------------------------------------------
 * Mat.Cha Do - instant navigation (Speculation Rules API)
 *
 * When a shopper hovers a link, the browser quietly loads that
 * page in the background, so the click feels instant. Added here
 * because constants.js is loaded on every page of the theme.
 *
 * Cart, checkout and account are excluded on purpose - those
 * pages change server state and must never be pre-rendered.
 * Browsers without support simply skip this.
 * ------------------------------------------------------------ */
(function () {
  try {
    if (!HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) return;

    var rules = {
      prerender: [
        {
          where: {
            and: [
              { href_matches: '/*' },
              { not: { href_matches: '/cart*' } },
              { not: { href_matches: '/checkout*' } },
              { not: { href_matches: '/account*' } },
              { not: { href_matches: '/*?*' } },
              { not: { selector_matches: '[data-no-prerender]' } }
            ]
          },
          eagerness: 'moderate'
        }
      ]
    };

    var tag = document.createElement('script');
    tag.type = 'speculationrules';
    tag.textContent = JSON.stringify(rules);
    document.head.appendChild(tag);
  } catch (e) {
    /* Never let a speculation failure break the page. */
  }
})();
